const playVideoOnExternalBtn = () => {
  const externalPlayBtns = document.querySelectorAll(
    ".js-external-video-play-btn"
  );
  externalPlayBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      console.log(btn.href);
      if (btn.href?.includes("majema.se")) {
        window.location.href = btn.href;
        return;
      }
      const parent = btn.closest("section");
      if (parent == null) return;
      const video = parent.querySelector(".videowrapper");
      if (video == null) return;
      video.click();
      setTimeout(() => {
        const iframe = video.querySelector("iframe");
        if (iframe) {
          var symbol = iframe.src.indexOf("?") > -1 ? "&" : "?";
          iframe.src += symbol + "autoplay=1&mute=1";
        }
      }, 2000);
    });
  });
};

const updateCartTotal = () => {
  const cartTotal = document.querySelector(".btn-update-total-price");
  if (!cartTotal) {
    return;
  }
  const updateCart = () => {
    // var cartContents = fetch(window.Shopify.routes.root + "cart.js")
    //   .then((response) => response.json())
    //   .then((data) => {

    //   });
    const cartItems = document.querySelectorAll(".cart-item-update");
    const updates = {};

    // Iterate over each cart item
    cartItems.forEach((item) => {
      const id = item.id.replace("updates_", "");
      const qty = item.value;

      // Add the ID and quantity to the updates object
      updates[id] = parseInt(qty);
    });

    // Prepare the data for the fetch request
    const data = {
      updates: updates,
    };

    // Make the fetch request to update the cart
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error updating the cart: " + response.statusText);
        }
      })
      .then((data) => {
        const price = parseFloat(
          (data.total_price / 100).toFixed(2)
        ).toLocaleString("en-US");

        const cartSummary = document.querySelector(".cart__summary p ");
        if (cartSummary) {
          console.log(`Ordersumma exkl. moms ${price} kr`);
          cartSummary.textContent = `Ordersumma exkl. moms ${price} kr`;
        }
        const cartItems = document.querySelectorAll(".cart-item");
        cartItems.forEach((item) => {
          const itemData = data.items.find((el) => el.key == item.dataset.key);
          if (itemData) {
            const itemTotal = item.querySelector(".cart__currentprice");
            itemTotal.textContent = parseFloat(
              (itemData.final_line_price / 100).toFixed(2)
            ).toLocaleString("en-US");
          }
        });
        window.cartData = data;
      })
      .catch((error) => {
        console.error("Error updating the cart:", error);
      });
  };

  cartTotal.addEventListener("click", (e) => {
    e.preventDefault();
    setTimeout(() => {
      updateCart();
    }, 300);
  });
  const qtyInputs = document.querySelectorAll(".cart-item-update");
  qtyInputs.forEach((input) => {
    input.addEventListener("change", () => {
      setTimeout(() => {
        updateCart();
      }, 300);
    });
  });
};

window.addEventListener("DOMContentLoaded", () => {
  playVideoOnExternalBtn();
  updateCartTotal();
});

// document.addEventListener("DOMContentLoaded", () => {
//   const allElements = document.querySelectorAll("p, span, button, a");
//   let encoder = new TextEncoder();

//   allElements.forEach((element) => {
//     element.innerHTML = element.innerHTML
//       .replaceAll("Ã¥", "å")
//       .replaceAll("Ã¤", "ä")
//       .replaceAll("Ã¶", "ö")
//       .replaceAll("Ã©", "é")
//       .replaceAll("Ã", "à") // adjust based on context if needed
//       .replaceAll("Ã«", "ë") // adjust based on context if needed
//       .replaceAll("Ã¼", "ü") // adjust based on context if needed
//       .replaceAll("â", "a") // adjust based on context if needed
//       .replaceAll("ê", "e") // adjust based on context if needed
//       .replaceAll("®", "r");
//   });
// });
